import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import Img1 from '../../Images/About/personalized.png'
import Img2 from '../../Images/About/destination.png'
import Img3 from '../../Images/About/advice.png'
import Img4 from '../../Images/About/itinerary.png'
import Img5 from '../../Images/About/customer-service.png'
import Img6 from '../../Images/About/picture.png'


const fadeIn = {
  hidden: { opacity: 0, y: 30 },
  visible: (i = 1) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.1,
      duration: 0.4,
      ease: "easeOut",
    },
  }),
};

export default function AboutUs() {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/"); // 👈 go to home page (adjust path if needed)
  };

  return (
    <div className="max-w-screen-xl mt-44 mb-20 mx-auto py-16 px-6 md:px-20">
      <motion.h1
        initial="hidden"
        animate="visible"
        variants={fadeIn}
        className="text-3xl md:text-4xl font-extrabold text-center text-yellow-600 mb-12"
      >
        ✈️ About Vamika Tours
      </motion.h1>

      <motion.div
        custom={1}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeIn}
        className="grid lg:grid-cols-2 gap-10 items-center"
      >
        <img
          src="https://images.unsplash.com/photo-1507525428034-b723cf961d3e"
          alt="Travel"
          className="rounded-3xl shadow-lg w-full h-auto object-cover"
        />
        <div className="space-y-6">
          <motion.p
            custom={2}
            variants={fadeIn}
            className="text-lg leading-relaxed text-gray-700"
          >
            Welcome to <span className="font-semibold text-yellow-600">Vamika Tours</span>, a newly emerging travel company based in Ahmedabad, where your journey begins with a smile and ends with unforgettable memories.
          </motion.p>
          <motion.p
            custom={3}
            variants={fadeIn}
            className="text-lg leading-relaxed text-gray-700"
          >
            Whether it's a beach getaway, thrilling adventure, cultural escape, or a romantic honeymoon – we turn your travel dreams into reality.
          </motion.p>
        </div>
      </motion.div>

      <motion.div
        custom={4}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeIn}
        className="mt-20 text-center"
      >
        <h2 className="text-3xl font-bold text-yellow-600 mb-6">Why Travel with Us?</h2>
        <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {[
            {
              point: "✓ Personalized service",
              imgSrc: Img1,
            },
            {
              point: "✓ Handpicked destinations",
              imgSrc: Img2,
            },
            {
              point: "✓ Expert travel advice",
              imgSrc: Img3,
            },
            {
              point: "✓ 24/7 support",
              imgSrc: Img5,
            },
            {
              point: "✓ Customized itineraries",
              imgSrc: Img4,
            },
            {
              point: "✓ Lifelong memories",
              imgSrc: Img6,
            },
          ].map((card, index) => (
            <motion.div
              key={index}
              custom={index + 5}
              variants={fadeIn}
              className="bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              <div className="flex items-center space-x-4">
                <img
                  src={card.imgSrc}
                  alt="Card Icon"
                  className="w-16 h-16 object-cover rounded-xl"
                />
                <p className="text-yellow-700 font-medium">{card.point}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>

      <motion.div
        custom={10}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeIn}
        className="mt-20 text-center"
      >
        <h2 className="text-2xl md:text-3xl font-bold text-yellow-600 mb-4">
          Let’s Explore the World Together 🌍
        </h2>
        <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
          At Vamika Tours, we don’t just plan trips — we create memories. Join us on a journey you’ll never forget!
        </p>
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={handleNavigate}
          className="bg-yellow-500 text-white px-6 py-3 rounded-full font-semibold shadow-md hover:bg-yellow-600 transition"
        >
          Start Your Journey
        </motion.button>
      </motion.div>
    </div>
  );
}
